<template>
  <div style="height: auto;width: 100%;" class="cargo-advance-search quotation-client-search">
    <div class="cargo-advance-search-header">
      <div class="cargo-advance-search-quick">
        <div class="section form-row">
          <el-form
            label-position="left"
            style="width: 100%;"
            label-width="75px"
          >
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item :label="$t('Pricing.ClientName')">
                  <el-input v-model="filter.name" no="name" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('Pricing.Owner')">
                  <cargo-user-select
                    no="category"
                    :method-params="{category:'role',shape:'sales'}"
                    style="width: 170px"
                    :default-value="filter.ownerId||''"
                    @change="p=>{filter.ownerId=p.value}"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div ref="searchOperations" style="margin-top: 10px; margin-bottom: 10px;" class="cargo-advance-search-operations">
        <el-button no="toQuery" type="primary" @click="toQuery">
          {{ $t('CargoMsg.Cargo_Query') }}
        </el-button>
        <el-button no="resetSearch" type="primary" @click="resetSearch()">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
        <slot name="operations">
          <!--页面操作按钮-->
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import StrUtils from '@/utils/StrUtils'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'

export default {
  name: 'QuotationClientSearchBar',
  components: { CargoUserSelect },
  props: {
    filter: {
      type: Object, default: () => {
        return {}
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
    toQuery() {
      this.proxy = {}
      const { name, ownerId } = this.filter
      if (!StrUtils.isEmpty(name)) {
        this.proxy['name'] = name
      }
      if (ownerId && ownerId > 0) {
        this.proxy['ownerId'] = ownerId
      }
      this.proxy['isLimited'] = true
      this.$emit('advSearchItemResetCallBack', this.proxy)
    },
    resetSearch() {
      this.filter = PriceUtils.resetFilter(this.filter)
    }
  }
}
</script>

<style lang="scss">
.quotation-client-search{
  input.el-input__inner{
    width: 100% !important;
  }
  .el-row {
    margin-right: 5px !important;
  }
}
</style>
